import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  logs: {
    alignSelf: 'flex-end',
    float: 'right',
  },
});

export default useStyles;
